import React from "react";
import { ColorV2 } from "config/colors";
import { CustomIcon } from "components/icon/customIcon.component";
import { TimePickerSize, TimePickerState } from "./timePicker.types";
import { FieldWrapper, IconWrapper, Input } from "./timePicker.styles";

export interface TimePickerInputProps {
  value: string;
  placeholder: string;
  ariaLabel?: string;
  disabled?: boolean;
  visualState: TimePickerState;
  size: TimePickerSize;
  isOpen: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  triggerRef: React.RefObject<HTMLDivElement>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onToggle: () => void;
}

/** Renders the input field and toggle icon. */
export const TimePickerInput = (
  props: TimePickerInputProps,
): React.ReactElement => {
  return (
    <FieldWrapper
      ref={props.triggerRef}
      $state={props.visualState}
      $size={props.size}
    >
      <Input
        type="text"
        aria-label={props.ariaLabel}
        value={props.value}
        placeholder={props.placeholder}
        disabled={props.disabled}
        $state={props.visualState}
        $size={props.size}
        ref={props.inputRef}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onKeyDown={props.onKeyDown}
      />
      <IconWrapper
        type="button"
        aria-label="Toggle time picker"
        disabled={props.disabled}
        onClick={props.onToggle}
      >
        <CustomIcon
          name={props.isOpen ? "v2/up-chevron" : "v2/down-chevron"}
          size="24px"
          color={
            props.visualState === "error" ? ColorV2.NegativeRed : ColorV2.Blue5
          }
        />
      </IconWrapper>
    </FieldWrapper>
  );
};
